<template>
  <div class="iDalgo-Stat">
    <div class="iDalgo-Stat__Icon">
      <template v-if="svg">
        <svgicon :name="svg" :original="true"></svgicon>
      </template>
      <template v-if="image">
        <img :src="image" />
      </template>
    </div>
    <div class="iDalgo-Stat__Content">
      <h5>{{ text }}</h5>
      <b>{{ subTitle }}</b>
    </div>
  </div>
</template>

<script>
import '@/components/icons'
export default {
  name: 'iDalgo-Stat',
  props: {
    value: {
      type: [String, Number, Array],
      required: true
    },
    unit: {
      type: String,
      required: true
    },
    subTitle: {
      type: String
    },
    svg: {
      type: String
    },
    image: {
      type: String,
      required: false
    }
  },
  computed: {
    text () {
      return `${this.value} ${this.unit}`
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Stat {
  display: flex;
  flex-flow: column;
  padding: 20px 16px 60px 16px;
  justify-content: center;
  text-align: center;

  &__Icon {

    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      max-height: 24px;
      max-width: 27px;
      path {
        opacity: 0.1;
      }
    }

    img {
      height: 32px;
      width: 32px;
      filter: grayscale(100%);
      opacity: 0.15;
    }
    margin-bottom: 12px;
  }

  &__Content {
    font-family: 'source_sans_proregular', sans-serif;
    h5 {
      font-family: 'source_sans_prosemibold', sans-serif;
      font-size: 36px;
      color: $color1;
      line-height: 1;
      margin: 0;
    }

    b {
      font-family: 'source_sans_proregular', sans-serif;
      font-size: 12px;
      font-weight: normal;
    }
  }

  @media (max-width: 640px) {
    padding-bottom: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Stat.vue